import type { ScheduleChangeAction } from '@ctms/contracts';

/**
 * Polish labels of the two manual schedule change log actions (issue #29
 * B6/B7 — approved wireframe
 * `spec/domains/patients-pathways/ui/manual-schedule-changes.ui.md`, gate of
 * 2026-10-22). A separate PL map per the client decision of 2026-10-14
 * (`decision-labels.ts` precedent); becomes the `pl` namespace when an i18n
 * runtime is introduced. The `Record` type forces completeness through `tsc`.
 *
 * The DTO schemas live in `@ctms/contracts` (`patients/schedule-log.schema.ts`
 * — the single seam the api layer and components import; migration 0023).
 */
export const SCHEDULE_ACTION_LABELS: Record<ScheduleChangeAction, string> = {
  added: 'Dodano',
  removed: 'Usunięto',
};
